import { createAsyncThunk } from "@reduxjs/toolkit";
import { loginAPI } from "../../../processes/api/login";
import {
  ITokenResponseData,
  IUserDetailResponseData,
  IUserLoginRequestData,
} from "./userTypes";
import { getUserInformationAPI } from "../../../processes/api/user";

export const loginThunk = createAsyncThunk<
  ITokenResponseData,
  IUserLoginRequestData
>("user/loginThunk:fetch", async (data: IUserLoginRequestData) => {
  const response = await loginAPI(data);

  return response.data;
});

export const getUserInformationThunk =
  createAsyncThunk<IUserDetailResponseData>(
    "user/getUserInformation:fetch",
    async () => {
      const response = await getUserInformationAPI();

      return response.data;
    }
  );
